import { styled } from "@mui/material/styles";
const ModalWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  background: theme.palette.grey[100]
}));
const WRAPPER_MARGIN = 6;
const AppointmentsWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "width" && props !== "offset" && props !== "limit"
})(
  ({ width, offset, limit }) => `
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${width}px;
  margin: ${offset}px ${WRAPPER_MARGIN}px ${limit}px;
`
);
const BORDER_HEIGHT = 2;
const Interval = styled("div", {
  shouldForwardProp: (props) => props !== "top"
})(
  ({ theme, top }) => `
  position: absolute;
  width: calc(100% + ${WRAPPER_MARGIN * 2}px);
  left: -${WRAPPER_MARGIN}px;
  height: ${BORDER_HEIGHT}px;
  background: ${theme.palette.grey[300]};
  top: ${top}%;
 `
);
export {
  AppointmentsWrapper,
  Interval,
  ModalWrapper
};
